import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, onMounted } from 'vue'
import { useShowModal, useConfirmWithPromise } from '@/composables/useModalOpener'
import useGlobal from '@/composables/useGlobal'
import { $vfm } from 'vue-final-modal'

const PENDING_EVENT_KEY = 'pendingEventRegistration'


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestFormWrapper',
  props: {
  periods: {
    type: Array,
  },
  eventId: {
    type: Number,
  },
  price: {
    type: Number,
  },
  videoPrice: {
    type: Number,
  },
  actualPrice: {
    type: Number,
  },
  registrationCompleted: {
    type: Boolean,
  },
  pastEvent: {
    type: Boolean,
  },
  canBuyVideo: {
    type: Boolean,
  },
  userHasEvent: {
    type: Boolean,
  },
  cartType: {
    type: String,
  },
  registrationTime: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const page403Url = window.page403Url
const userIsAuthenticated = window.isAuthenticated

const props = __props

const { $t } = useGlobal()
const formdata = reactive({
  period: {},
})

// Показ QR одразу після успішної реєстрації на офлайн-захід.
// Бекенд передає в redirect лише ?token=<uuid> (offline/offline_online).
// URL картинки будується на клієнті за фіксованим шаблоном — НІКОЛИ
// не береться з query, щоб унеможливити XSS через довільний href/src.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const registrationQr = ref<{ token: string, qrImageUrl: string } | null>(null)

const selectDate = (period: any) => {
  formdata.period = period
}

const openEventModal = (eventId: number, periodId: number) => {
  $vfm.show({
    component: 'UiModalContainer',
  }, {
    classes: 'modal--size_lg',
    component: 'Events/RequestFormEvent',
    periodId: periodId,
    eventId: eventId,
  })
}

const openRegistrationQrModal = (token: string, qrImageUrl: string) => {
  $vfm.show({
    component: 'UiModalContainer',
  }, {
    classes: 'modal--size_sm',
    component: 'Events/RegistrationQrCard',
    token,
    qrImageUrl,
  })
}

const confirmRegistration = async () => {
  if (!userIsAuthenticated) {
    const message = {
      title: $t('Увага!'),
      text: $t('Необхідно авторизуватися для створення заявки. Продовжити?'),
    }
    await useConfirmWithPromise(message)
    sessionStorage.setItem(PENDING_EVENT_KEY, JSON.stringify({
      eventId: props.eventId,
      periodId: formdata.period.id || null,
      eventUrl: window.location.pathname,
    }))
    window.location.href = page403Url
  } else {
    if (formdata.period.id || props.canBuyVideo) {
      openEventModal(props.eventId, formdata.period.id)
    } else {
      const message = {
        title: $t('Спочатку оберіть дату на яку бажаете записатись'),
      }

      useShowModal(message)
    }
  }
}

onMounted(() => {
  // Показати повідомлення про успішну реєстрацію якщо є ?registered=1 в URL
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('registered') === '1') {
    // Показати QR лише якщо бекенд передав валідний token в redirect
    // (URL-параметр з картинкою НЕ приймається — будується самостійно).
    // Якщо QR для заходу вимкнено (disable_qr_checkin) - token в redirect
    // відсутній, і показується звичайне повідомлення про успіх.
    const token = urlParams.get('token')
    if (token && UUID_RE.test(token)) {
      const qrImageUrl = `/events/qr/${token}.png`
      registrationQr.value = { token, qrImageUrl }
      openRegistrationQrModal(token, qrImageUrl)
    } else {
      const message = {
        title: $t('Вітаємо!'),
        text: $t('Вас успішно зареєстровано на захід'),
      }
      useShowModal(message)
    }

    // Прибрати параметри з URL без перезавантаження сторінки
    const url = new URL(window.location.href)
    url.searchParams.delete('registered')
    url.searchParams.delete('token')
    window.history.replaceState({}, '', url.toString())
  }

  const pending = sessionStorage.getItem(PENDING_EVENT_KEY)
  if (!pending || !userIsAuthenticated) return

  try {
    const { eventId, periodId } = JSON.parse(pending)
    if (eventId !== props.eventId) return

    sessionStorage.removeItem(PENDING_EVENT_KEY)

    if (periodId) {
      const period = (props.periods as any[])?.find(p => p.id === periodId)
      if (period) formdata.period = period
    }

    openEventModal(eventId, periodId)
  } catch (e) {
    sessionStorage.removeItem(PENDING_EVENT_KEY)
  }
})

const __returned__ = { PENDING_EVENT_KEY, page403Url, userIsAuthenticated, props, $t, formdata, UUID_RE, registrationQr, selectDate, openEventModal, openRegistrationQrModal, confirmRegistration, reactive, ref, onMounted, get useShowModal() { return useShowModal }, get useConfirmWithPromise() { return useConfirmWithPromise }, get useGlobal() { return useGlobal }, get $vfm() { return $vfm } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})